if (!customElements.get('delivery-times')) {
  customElements.define(
    'delivery-times',
    class DeliveryTimes extends HTMLElement {
      constructor(){
        super();

        var compare_date = new Date()
        var w_d = 0, standard_min_date, standard_max_date, express_min_date, express_max_date
        
        const working_days = this.dataset.workingDays.split(",").map(elem=> parseInt(elem, 10)),
              standardMin = parseInt(this.dataset.standardDaysMin),
              standardMax = parseInt(this.dataset.standardDaysMax), 
              expressMin = parseInt(this.dataset.expressDaysMin), 
              expressMax = parseInt(this.dataset.expressDaysMax),
              deliveryMin = parseInt(this.dataset.deliveryMin) || 1,
              deliveryMax = parseInt(this.dataset.deliveryMax) || 1,
              holidays = [];
        this.querySelectorAll('holiday-date').forEach( (element) => {
          holidays.push(new Date(element.innerText))
        })

        if(compare_date.getHours() < this.cutoff) w_d += 1;
        dayLoop: for(var i=0; i<100; i++){
          compare_date.setDate(compare_date.getDate()+1);
          for(var h=0; h<holidays.length; h++){
            if(holidays[h].getDate() == compare_date.getDate() && holidays[h].getMonth() == compare_date.getMonth() && holidays[h].getYear() == compare_date.getYear()) {
              continue dayLoop;
            }
          }
          if(working_days.includes(parseInt(compare_date.getDay()))) {
            w_d += 1;
          } else {
            continue dayLoop;
          }
          console.log(w_d,standardMin, deliveryMin)
          if(w_d == (standardMin + deliveryMin)) {standard_min_date = new Date(compare_date)}
          if(w_d == (expressMin + deliveryMin)) {express_min_date = new Date(compare_date)}
          if(w_d == (expressMax + deliveryMax)) {express_max_date = new Date(compare_date)}
          if(w_d == (standardMax + deliveryMax)){standard_max_date = new Date(compare_date); break}
        }
        
        this.querySelectorAll('delivery-message.standard-production').forEach((element) => {
          if (element.querySelector('span[data-type="min"]')) element.querySelector('span[data-type="min"]').innerText = this.fmt(standard_min_date);
          if (element.querySelector('span[data-type="max"]')) element.querySelector('span[data-type="max"]').innerText = this.fmt(standard_max_date);
          if (element.querySelector('span[data-type="min-short"]')) element.querySelector('span[data-type="min-short"]').innerText = this.fmt_short(standard_min_date) + " - ";
          if (element.querySelector('span[data-type="max-short"]')) element.querySelector('span[data-type="max-short"]').innerText = this.fmt_short(standard_max_date);
        })
        this.querySelectorAll('delivery-message.express-production').forEach((element) => {
          if (element.querySelector('span[data-type="min"]')) element.querySelector('span[data-type="min"]').innerText = this.fmt(express_min_date);
          if (element.querySelector('span[data-type="max"]')) element.querySelector('span[data-type="max"]').innerText = this.fmt(express_max_date);
          if (element.querySelector('span[data-type="min-short"]')) element.querySelector('span[data-type="min-short"]').innerText = this.fmt_short(express_min_date) + " - ";
          if (element.querySelector('span[data-type="max-short"]')) element.querySelector('span[data-type="max-short"]').innerText = this.fmt_short(express_max_date);
          if(express_min_date.getDate() == express_max_date.getDate()) element.querySelector('span[data-type="min-short"]').innerText = "";
        })
      }

      market(){
        var lang = (window.Shopify && Shopify.locale ? Shopify.locale : 'en').split('-')[0]
        if (lang == 'en' && window.Shopify && Shopify.country == 'US') return 'us'
        return lang
      }

      fmt(date){
        var d = date.getDate()
        switch (this.market()){
          case 'us':
            return this.day(date) + ", " + this.mnth(date) + " " + d
          case 'de':
            return this.day(date) + ", " + d + ". " + this.mnth(date)
          case 'fr':
            return this.day(date) + " " + (d == 1 ? '1er' : d) + " " + this.mnth(date)
          case 'sv':
            return this.day(date) + " " + d + " " + this.mnth(date)
          default:
            return this.day(date) + " " + d + this.ord(d) + " " + this.mnth(date)
        }
      }

      fmt_short(date){
        var d = date.getDate()
        switch (this.market()){
          case 'us':
            return this.day_short(date) + " " + d
          case 'de':
            return this.day_short(date) + " " + d + "."
          case 'fr':
            return this.day_short(date) + " " + (d == 1 ? '1er' : d)
          case 'sv':
            return this.day_short(date) + " " + d
          default:
            return this.day_short(date) + " " + d + this.ord(d)
        }
      }

      mnth(date){
        return date.toLocaleDateString(Shopify.locale, {month: 'long'})
      }

      day(date){
        return date.toLocaleDateString(Shopify.locale, {weekday: 'long'})
      }

      day_short(date){
        return date.toLocaleDateString(Shopify.locale, {weekday: 'short'})
      }

      ord(date){
        switch (parseInt(date)){
          case 1:
            return 'st'
          case 2:
            return 'nd'
          case 3:
            return 'rd'
          case 21:
            return 'st'
          case 22:
            return 'nd'
          case 23:
            return 'rd'
          case 31:
            return 'st'
          default:
            return 'th'
        }
      }

      get standardMin () {
        return parseInt(this.dataset.standardDaysMin)
      }

      get standardMax () {
        return parseInt(this.dataset.standardDaysMax)
      }

      get deliveryMin () {
        return parseInt(this.dataset.deliveryMin)
      }

      get deliveryMax () {
        return parseInt(this.dataset.deliveryMax)
      }

      get expressMin () {
        return parseInt(this.dataset.expressDaysMin)
      }

      get expressMax () {
        return parseInt(this.dataset.expressDaysMax)
      }

      get cutoff () {
        return parseInt(this.dataset.cutoffTime)
      }
    }
  )
}